import type { ChapterBoard } from "../timeline/board";
import type { BookTimelineLayout } from "../timeline/book/BookLayout";
import {
  timelineGpuSceneFromBoard,
  timelineGpuSceneFromLayout,
  type TimelineGpuScene,
} from "../timeline/board/ChapterBoard/gpuScene";
import type { PlaybackState } from "../timeline/playback";
import type { TimelineViewState } from "./render-frame";

export interface TimelineGpuRuntime {
  layout: BookTimelineLayout;
  /** When set, rail/branch GPU geometry comes from the chapter board. */
  chapterBoard?: ChapterBoard;
  getPlayback: () => PlaybackState;
  getViewportWidth: () => number;
  getViewTransform: () => TimelineViewState;
  resolveViewTransform?: () => TimelineViewState;
}

export function resolveTimelineGpuScene(
  runtime: TimelineGpuRuntime,
): TimelineGpuScene {
  if (runtime.chapterBoard !== undefined) {
    return timelineGpuSceneFromBoard(runtime.chapterBoard);
  }
  return timelineGpuSceneFromLayout(runtime.layout);
}
